import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const quickReplies = [
  'Admission guidance',
  'Visa support',
  'Country options',
  'Talk to counsellor',
];

const responseMap = {
  'admission guidance': {
    text: 'We help with profile evaluation, college shortlisting, SOP guidance, application support, and planning for your target intake.',
    link: { to: '/services', label: 'View Services' },
  },
  'visa support': {
    text: 'Yes, Vedanskrix supports visa documentation review, checklist guidance, and interview preparation for students.',
    link: { to: '/process', label: 'See Process' },
  },
  'country options': {
    text: 'Our main student destinations include the UK, USA, Canada, Australia, and the Netherlands.',
    link: { to: '/countries', label: 'Explore Countries' },
  },
  'talk to counsellor': {
    text: 'You can contact our admission team on +91 8758637022 or send your details through the contact page.',
    link: { to: '/contact', label: 'Open Contact Page' },
  },
};

function AiChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: 'bot',
      text: 'Welcome to Vedanskrix College Admission. Ask about admissions, countries, visa support, or counselling.',
      link: { to: '/contact', label: 'Book Counselling' },
    },
  ]);

  const fallback = useMemo(
    () => ({
      text: 'I can help with admission guidance, country options, visa support, and connecting you to our counsellor.',
      link: { to: '/services', label: 'Admission Services' },
    }),
    []
  );

  const pushReply = (prompt) => {
    const key = prompt.trim().toLowerCase();
    const reply = responseMap[key] || fallback;

    setMessages((current) => [
      ...current,
      { id: current.length + 1, sender: 'user', text: prompt },
      { id: current.length + 2, sender: 'bot', ...reply },
    ]);
  };

  return (
    <div className="ca-chat">
      {open ? (
        <section className="ca-chat__panel" aria-label="College admission AI chat">
          <header className="ca-chat__header">
            <div>
              <strong>Admission AI Chat</strong>
              <p>Quick help for students</p>
            </div>
            <button type="button" onClick={() => setOpen(false)} aria-label="Close chat">
              x
            </button>
          </header>

          <div className="ca-chat__messages">
            {messages.map((message) => (
              <div
                key={message.id}
                className={message.sender === 'bot' ? 'ca-chat__bubble ca-chat__bubble--bot' : 'ca-chat__bubble ca-chat__bubble--user'}
              >
                <p>{message.text}</p>
                {message.link ? (
                  <Link to={message.link.to} className="ca-chat__link">
                    {message.link.label}
                  </Link>
                ) : null}
              </div>
            ))}
          </div>

          <div className="ca-chat__actions">
            {quickReplies.map((reply) => (
              <button key={reply} type="button" onClick={() => pushReply(reply)}>
                {reply}
              </button>
            ))}
          </div>
        </section>
      ) : null}

      <button
        type="button"
        className="ca-chat__toggle"
        onClick={() => setOpen((current) => !current)}
        aria-label="Open admission AI chat"
      >
        AI
      </button>
    </div>
  );
}

export default AiChatWidget;
